export default {
    ai: 'Asystent AI',
    export: 'Eksportuj',
    blue: 'Niebieski',
    yellow: 'Żółty',
    pink: 'Różowy',
    orange: 'Pomarańczowy',
    all: 'Wszystkie',
    generateApaCopy: 'Generuj cytowanie APA',
    apaCopied: 'Skopiowano cytowanie do schowka!',
    imReading: 'Czytam',
    in: 'w',
    by: 'Autor',
    article: 'Artykuł',
    prevArticle: 'Poprzedni artykuł',
    nextArticle: 'Następny artykuł',
    imHere: 'Tak, jestem tutaj',
    sessionExpiredAlert: 'Twoja sesja czytania wkrótce wygaśnie.',
    sessionExpiredAreYouThere: 'Jesteś tam?',
    sessionExpired: 'Twoja sesja wygasła z powodu braku aktywności.',
    returnToLibrary: 'Wróć do biblioteki',
    sessionValidExpired: 'Sesja wygasła',
    sessionValidExpiredPleaseLoginAgain: 'Zaloguj się ponownie',
    tableOfContents: 'Spis treści',
    tableOfContentsNotAvailable: 'Spis treści niedostępny.',
    pages: 'strony',
    page: 'strona',
    thumbnails: 'Miniatury',
    settings: 'Ustawienia',
    bookmarks: 'Zakładki',
    highlights: 'Zaznaczenia',
    highlight: 'Zaznacz',
    notes: 'Notatki',
    note: 'Notatka',
    notebook: 'Notes',
    search: 'Szukaj',
    theme: 'Motyw',
    readingModes: 'Tryby czytania',
    zoomTitle: 'Rozmiar tekstu',
    zoomTitlePdf: 'Powiększenie',
    zoomTimes: 'Razy',
    typography: 'Typografia',
    fontDefault: 'Domyślna',
    lineSpacing: 'Interlinia',
    lineSpacingCompact: 'Kompaktowy',
    lineSpacingNormal: 'Normalny',
    lineSpacingWide: 'Szeroki',
    margins: 'Marginesy',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normalny',
    marginsMaximum: 'Maksimum',
    pageLayout: 'Układ strony',
    continuous: 'Ciągły',
    onePage: 'Poziomy',
    onePageScroll: 'Pionowy',
    twoPages: 'Podwójny',
    twoPagesScroll: 'Przewijanie dwóch stron',
    citation: {
        buttons: {
            Iso690: 'Generuj cytowanie ISO690',
            APA: 'Generuj cytowanie APA',
            Vancouver: 'Generuj cytowanie Vancouver',
            IEEE: 'Generuj cytowanie IEEE',
            MLA: 'Generuj cytowanie MLA',
            ABNT: 'Generuj cytowanie ABNT',
        },
        menu: {
            title: 'Generuj cytowanie',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Skopiowano cytowanie do schowka!',
            availableIn: 'Dostępne w',
            online: 'Internet',
            generated: 'cytowane',
            websiteName: 'publica.la',
            and: 'i',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Wyjaśnij pojęcie',
            expand: 'Rozszerz informacje',
            summarize: 'Podsumuj ideę',
        },
        menu: {
            title: 'Asystent AI (Beta)',
        },
        messages: {
            copied: 'Skopiowano odpowiedź do schowka!',
            addedToResponse: '«Odpowiedź skopiowana z publica.la Reader»',
        },
        thanksFeedback: 'Dziękujemy za opinię!',
        errorFeedback: 'Nie udało się wysłać opinii. Spróbuj ponownie?',
    },
    onlyCopy: 'Kopiuj zwykły tekst',
    translate: 'Tłumacz',
    copy: 'kopiuj',
    changeColor: 'Zmień kolor',
    socialShare: 'Udostępnij',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Dopasuj do strony',
        'page-width': 'Szerokość strony',
    },
    filter: 'Filtruj',
    noFilterHighlights: 'Wybierz filtr, aby zobaczyć zaznaczenia',
    noFilterHighlightsColor: 'Brak zaznaczeń w tym kolorze',
    noHighlights: 'Nie masz jeszcze zaznaczeń',
    noFilterNotes: 'Wybierz kolor, aby zobaczyć notatki',
    noFilterNotesColor: 'Brak notatek w tym kolorze',
    noNotes: 'Nie masz jeszcze notatek',
    noFilterHighlightsAndNotes: 'Wybierz kolor, aby zobaczyć zaznaczenia i notatki',
    noFilterHighlightsAndNotesColor: 'Brak notatek i zaznaczeń w tym kolorze',
    noHighlightsAndNotes: 'Nie utworzono jeszcze zaznaczeń ani notatek',
    plainCopied: 'Skopiowano tekst do schowka!',
    onboarding: {
        next: 'Dalej',
        finish: 'Zakończ',
        skip: 'Pomiń samouczek',
        previous: 'Wstecz',
        reader: {
            welcome: {
                title: 'Witaj w swojej przestrzeni do czytania',
                paragraph: 'Odkryj, jak najlepiej wykorzystać narzędzia dostępne w czytniku.',
                extraParagraph: 'Ciesz się nową przestrzenią do czytania!',
            },
            highlights: {
                title: 'Ulepsz swoje doświadczenie czytania',
                paragraph:
                    'Zaznaczaj tekst, twórz notatki, generuj cytaty, tłumacz i słuchaj treści. Podnieś swoje doświadczenie czytania na wyższy poziom we wszystkich formatach.',
            },
            resumes: {
                title: 'Zarządzaj swoją treścią',
                paragraph:
                    'Zwiększ swoją produktywność. Zarządzaj notatkami, zaznaczeniami, cytatami i podsumowaniami według własnych potrzeb. Dziel się swoimi pomysłami szybko i łatwo.',
            },
            appPromote: {
                title: 'Czytaj lub słuchaj gdziekolwiek jesteś',
                paragraph:
                    'Uzyskaj dostęp do swojej treści kiedy chcesz i jak chcesz, bez potrzeby połączenia z internetem, na wybranym urządzeniu.',
                extraParagraph: 'Pobierz naszą aplikację!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Witaj',
                subTitle: 'Jak korzystać z odtwarzacza audio?',
                paragraph: 'Dowiedz się, jak najlepiej wykorzystać słuchanie.',
            },
            reproduction: {
                title: 'Kontrola odtwarzania',
                paragraph: 'Przewijaj do przodu i do tyłu lub wstrzymuj odtwarzanie audiobooka.',
            },
            narratorSpeed: {
                title: 'Prędkość narracji',
                paragraph: 'Możesz wybrać dowolną prędkość dla aktualnie słuchanego audiobooka.',
            },
            chapters: {
                title: 'Rozdziały',
                paragraph: 'Przemieszczaj się między rozdziałami w szybki i sprawny sposób.',
            },
        },
    },
    author: 'Autor',
    publisher: 'Wydawca',
    narrator: 'Narrator',
    narratedBy: 'Czyta',
    aboutThisPublication: 'O tej publikacji',
    listening: {
        label: 'Słuchaj',
        voice: 'Głos',
    },
    searchResultEmpty: 'Nie znaleziono wyników',
    searchLengthError: 'Wyszukiwanie musi mieć od 4 do 128 znaków',
    keepTyping: 'Pisz dalej…',
    loading: 'Ładowanie...',
    searchLoading: 'Wyszukiwanie...',
    searchTitle: 'Szukaj',
    lastSearch: 'Sugestie',
    searchExplanation: 'Szybko znajdź słowa w całej publikacji',
    networkIsOffline: 'Brak połączenia z internetem. Niektóre funkcje są niedostępne.',
    about: 'O publikacji',
    chapters: 'Rozdziały',
    duration: 'Czas trwania',
    narratorSpeed: 'Prędkość narracji',
    slowNarration: 'Wolna narracja',
    normalNarration: 'Normalna narracja',
    fastNarration: 'Szybka narracja',
    shareIssue: 'Udostępnij publikację',
    shareArticle: 'Udostępnij artykuł',
    copyUrl: 'Kopiuj URL',
    shareCurrentPage: 'Udostępnij bieżącą stronę',
    shareCurrentPosition: 'Udostępnij bieżącą pozycję',
    copyUrlToClipboard: 'Skopiowano URL do schowka',
    tooltips: {
        zoomOut: 'Pomniejsz',
        zoomIn: 'Powiększ',
        config: 'Konfiguracja',
        tableOfContents: 'Spis treści',
        search: 'Szukaj',
        highlights: 'Zaznaczenia',
        notebook: 'Notes',
        listen: 'Słuchaj',
        bookmarks: 'Zakładki',
        openThumbnails: 'Miniatury',
        closeThumbnails: 'Zamknij miniatury',
        download: 'Dostęp offline',
        share: 'Udostępnij',
        prev: 'Poprzedni',
        next: 'Następny',
        close: 'Zamknij',
        back: 'Wstecz',
        themeTitle: 'Wygląd',
        themeLight: 'Jasny',
        themeDark: 'Ciemny',
        themeCream: 'Kremowy',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Wysoki kontrast',
        themeHighContrastDark: 'Wysoki kontrast ciemny',
        clear: 'Wyczyść',
        citation: 'Cytowanie',
        dictionary: 'Słownik',
        aiIntegrations: 'Asystent AI (Beta)',
        aiAction:
            'To narzędzie wykorzystuje AI, więc mogą pojawić się niedokładne informacje. Wkrótce więcej ulepszeń! Co o tym myślisz? Użyj poniższych ikon, aby podzielić się swoją opinią.',
        translate: 'Tłumacz',
        about: 'O publikacji',
        rewind: 'Przewiń do tyłu',
        forward: 'Przewiń do przodu',
        createNote: 'Utwórz notatkę',
        createHighlight: 'Zaznacz',
        deleteHighlight: 'Usuń zaznaczenie',
        help: 'Pomoc',
        lists: 'Listy',
        copy: 'Kopiuj',
        goodResponse: 'Dobra odpowiedź',
        badResponse: 'Zła odpowiedź',
        ai: 'Asystent AI',
        moreActions: 'Więcej działań',
        moreOptions: 'Więcej opcji',
        play: 'Odtwórz',
        pause: 'Pauza',
        seekPosition: 'Pozycja utworu',
        zoomReset: 'Resetuj zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Motyw systemowy',
        searchInBook: 'Szukaj w książce',
        pageSlider: 'Nawigacja po stronach',
    },
    save: 'Zapisz',
    delete: 'Usuń',
    cancel: 'Anuluj',
    confirmDelete: {
        title: 'Usuń notatkę',
        message: 'Czy na pewno chcesz usunąć tę notatkę? Tej akcji nie można cofnąć.',
    },
    confirmResetSettings: {
        title: 'Przywróć ustawienia',
        message: 'Wszystkie ustawienia wizualne zostaną przywrócone do wartości domyślnych.',
    },
    resetSettings: 'Przywróć ustawienia',
    writeNote: 'Napisz notatkę',
    speakNow: 'Mów teraz',
    listeningSpeech: 'Słuchanie',
    share: {
        copyShare: 'Kopiuj i udostępnij',
        qrCodeTitle: 'Kod QR',
        scanQr: 'Zeskanuj kod QR za pomocą aplikacji WeChat',
        copyLink: 'Kopiuj URL publikacji',
        copy: 'Kopiuj',
        copied: 'skopiowano!',
        openWechat: 'Otwórz aplikację WeChat',
        openingWechat: 'Otwieranie aplikacji WeChat...',
        sendCopiedUrl: 'Wyślij skopiowany URL do kontaktu',
    },
    playing: 'Odtwarzanie',
    buyNow: 'Kup teraz',
    buyNowText: 'Uzyskaj pełną wersję.',
    preview: 'Przykład',
    changeLayoutNotAllowed: 'Treść nie pozwala na zmianę układu strony',
    nativeTtsLang: {
        'en-US': 'English (United States)',
        'en-GB': 'English (United Kingdom)',
        'en-scotland': 'English (Scotland)',
        'en-AU': 'English (Australia)',
        'en-IE': 'English (Ireland)',
        'en-IN': 'English (India)',
        'en-ZA': 'English (South Africa)',
        en: 'English',
        'es-AR': 'Spanish (Argentina)',
        'es-ES': 'Spanish (Spain)',
        'es-MX': 'Spanish (Mexico)',
        'es-US': 'Spanish (United States)',
        es: 'Spanish',
        'it-IT': 'Italian (Italy)',
        it: 'Italian',
        'pt-PT': 'Portuguese (Portugal)',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        'fr-CA': 'French (Canada)',
        'fr-FR': 'French (France)',
        fr: 'French',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: 'Pobierz z App Store',
        downloadPlayStore: 'Pobierz z Google Play',
        title_read: 'Zabierz swoje lektury ze sobą z',
        title_audio: 'Zabierz swoje audiobooki ze sobą z',
        text: 'Uzyskaj dostęp do swojej treści kiedy chcesz i jak chcesz, bez potrzeby połączenia z internetem, na wybranym urządzeniu. Pobierz naszą aplikację!',
        title_first_part: 'Z',
        title_second_part: 'zabierz swoje czytanie ze sobą',
    },
    dictionary: 'Słownik',
    selectionTooLongLine1: 'Zaznaczenie zawiera zbyt wiele słów.',
    selectionTooLongLine2: 'Spróbuj zaznaczyć do 5 słów.',
    dictionaryValidation: {
        message: 'Zaznaczyłeś {count} słów.\nProszę spróbować zaznaczyć do {max} słów.',
    },
    translateValidation: {
        message: 'Zaznaczyłeś {count} znaków.\nProszę spróbować zaznaczyć do {max} znaków.',
    },
    ttsValidation: {
        message: 'Zaznaczyłeś {count} znaków.\nProszę spróbować zaznaczyć do {max} znaków.',
    },
    aiValidation: {
        message: 'Zaznaczyłeś {count} znaków.\nProszę zaznaczyć między {min} a {max} znaków.',
    },
    alreadyPurchased: 'Już zakupione?',
    logIn: 'Zaloguj się',
    addToAList: 'Dodaj do listy',
    nextSection: 'Następna sekcja',
    prevSection: 'Poprzednia sekcja',
    lists: 'Listy',
    new: 'Nowy',
    skipLinks: {
        navLabel: 'Linki szybkiego dostępu',
        showControls: 'Pokaż kontrolki',
    },
    accessibility: {
        textSelected: '{count} znaków zaznaczonych. Narzędzia zaznaczania dostępne.',
        pageChanged: 'Strona {current} z {total}',
    },
};
